import { convertPrice, getBaseRateSet, roundDisplayedRate, shouldRoundFixedPlanRate } from "./constructor_pricing.js";
import { shouldEnableLocation, shouldEnableProjectType, shouldShowPanels } from "./constructor_state.js";
import { PriceCalculator } from "./price_calculator.js";

export function buildConstructorViewModel(state, validation, quote, options) {
  const symbol = options.symbols[state.currency] || "€";
  const hasArea = state.area > 0;

  return {
    locationDisabled: !shouldEnableLocation(state),
    projectTypeDisabled: !shouldEnableProjectType(state),
    panelsHidden: !shouldShowPanels(state),
    partialRowShown: state.partialSelection.checked,
    razvortkyRowShown: state.razvortkySelection.checked,
    priceRowsHtml: quote.rows
      .map(
        (row) =>
          `<div class="price-line"><span>${escapeHtml(row.label)}</span><span>${PriceCalculator.formatAmount(row.amount)}&thinsp;${symbol}</span></div>`
      )
      .join(""),
    priceTotalText: hasArea ? `${PriceCalculator.formatAmount(quote.total)}\u2009${symbol}` : "—",
    optionLabels: buildProjectTypeOptionLabels(options.projectTypeOptions, state.currency, options),
    validation,
    actionButtonsDisabled: !options.htmlValid || !validation.isBusinessValid || validation.locationMissing,
  };
}

export function buildProjectTypeOptionLabels(projectTypeOptions, currency, options) {
  return projectTypeOptions.map((option) => {
    if (!option.value) {
      return { value: option.value, text: option.label };
    }

    const rate = convertPrice(getBaseRateSet(options.projectCategoryKey, option.value), currency, options);
    if (rate <= 0) {
      return { value: option.value, text: option.label };
    }

    const displayRate = shouldRoundFixedPlanRate(options.projectCategoryKey, currency)
      ? roundDisplayedRate(rate, currency)
      : rate;

    return {
      value: option.value,
      text: `${option.label} — ${PriceCalculator.formatRate(displayRate)}\u2009${options.symbols[currency] || "€"}/${options.areaUnit}`,
    };
  });
}

function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
